"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var style_1 = require("../../../style");
var layout_1 = require("../../layout");
var InputGroupButton_1 = __importDefault(require("./InputGroupButton"));
var InputGroupText_1 = __importDefault(require("./InputGroupText"));
var cloneElement = function (element, props) {
    var _a;
    return react_1.jsx(element.type, __assign(__assign({ key: (_a = element.key) !== null && _a !== void 0 ? _a : undefined }, element.props), props));
};
var getStyles = function (theme, size) {
    if (size === void 0) { size = 'default'; }
    return ({
        common: react_1.css({
            border: '1px solid ' + theme.color.GRAY.LIGHT_2,
            borderRadius: 6,
            height: size === 'small' ? 28 : 40,
        }),
        text: react_1.css({
            paddingLeft: size === 'small' ? 8 : 12,
            paddingRight: size === 'small' ? 8 : 12,
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#FFF',
            color: theme.color.GRAY.DEFAULT,
        }),
        noBorderLeft: react_1.css({
            borderLeftWidth: 0,
        }),
        noBorderRight: react_1.css({
            borderRightWidth: 0,
        }),
        noBorderRadiusLeft: react_1.css({
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
        }),
        noBorderRadiusRight: react_1.css({
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
        }),
        noBorderRadius: react_1.css({
            borderRadius: 0,
        }),
    });
};
var InputGroup = function (props) {
    var theme = style_1.useTheme();
    var _a = props.size, size = _a === void 0 ? 'default' : _a, rest = __rest(props, ["size"]);
    var styles = getStyles(theme, size);
    var children = react_2.useMemo(function () {
        return react_2.default.Children.map(props.children, function (child, i) {
            var childrenCount = react_2.default.Children.count(props.children);
            var stylesToApply = [styles.common];
            if (child.type === InputGroupText_1.default) {
                stylesToApply.push(styles.text);
            }
            if (i === 0) {
                stylesToApply.push(styles.noBorderRadiusRight);
            }
            else if (i === childrenCount - 1) {
                stylesToApply.push(styles.noBorderRadiusLeft, styles.noBorderLeft);
            }
            else if (i > 0 && i < childrenCount - 1) {
                stylesToApply.push(styles.noBorderRadius, styles.noBorderLeft);
            }
            return cloneElement(child, { css: stylesToApply, size: size });
        });
    }, [props.children, size, styles]);
    return (react_1.jsx(layout_1.Flex, __assign({ alignItems: "center", justifyContent: "flex-start" }, rest), children));
};
exports.default = Object.assign(InputGroup, {
    Text: InputGroupText_1.default,
    Button: InputGroupButton_1.default,
});
